import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBrowser = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		transform: "scale(1.2) translate(-10 -10)",
		stroke: "currentColor",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round",
		children: [
			/* @__PURE__ */ _jsx("path", { d: "M20 28.25C24.5563 28.25 28.25 24.5563 28.25 20C28.25 15.4437 24.5563 11.75 20 11.75C15.4437 11.75 11.75 15.4437 11.75 20C11.75 24.5563 15.4437 28.25 20 28.25Z" }),
			/* @__PURE__ */ _jsx("path", { d: "M20 28.25C21.933 28.25 23.5 24.5563 23.5 20C23.5 15.4437 21.933 11.75 20 11.75C18.067 11.75 16.5 15.4437 16.5 20C16.5 24.5563 18.067 28.25 20 28.25Z" }),
			/* @__PURE__ */ _jsx("path", { d: "M11.75 20H28.25" }),
			/* @__PURE__ */ _jsx("path", { d: "M13.5 16.25C15.2 15.3 17.4 14.75 20 14.75C22.6 14.75 24.8 15.3 26.5 16.25" }),
			/* @__PURE__ */ _jsx("path", { d: "M13.5 23.75C15.2 24.7 17.4 25.25 20 25.25C22.6 25.25 24.8 24.7 26.5 23.75" })
		]
	})
});
export default SvgBrowser;
